<template>
  <NewBsBox :bs="{'cmp.topBar': 'container', ...bs}">
    <NewBsBox :bs="{ 'cmp.topBar': 'wrapper'}">
      <NewBsBox :bs="{'cmp.topBar.left': 'wrapper'}">
        <NewBsBox
          :bs="{
            'cmp.topBar.left': 'title',
            ...titleBs,
          }"
        >
          <BeerIcon
            :size="72"
            :bs="{mr: 'x'}"
            icon="red-logo-f"
            color="#FF2442"
          />
          <NewBsBox :bs="{'cmp.topBar.left': 'textBox'}">
            {{ title }}
          </NewBsBox>
        </NewBsBox>
        <!--
          @slot 顶部导航插槽，推荐组合 TabHeaders 组件使用
        -->
        <slot name="nav" />
      </NewBsBox>
      <NewBsBox :bs="{'cmp.topBar.right': 'wrapper'}">
        <!--
        @slot 整个右侧区域插槽，可以定制自己的组件
         -->
        <slot name="right">
          <!-- @slot 自定义 action 按钮内容，推荐组合 ButtonGroup 使用 -->
          <slot name="actions" />
          <NewBsBox
            v-if="showAvatar"
            :bs="{'cmp.topBar.right': 'avatar'}"
            v-on="avatarOn"
          >
            <BeerAvatar
              v-bind="{
                bs: { mr: 'xs'},
                ...avatarProps,
              }"
            />
            <NewBsBox :bs="{'cmp.topBar.right': 'avatarText'}">
              {{ userName }}
            </NewBsBox>
          </NewBsBox>
        </slot>
      </NewBsBox>
    </NewBsBox>
  </NewBsBox>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import BeerAvatar from '@xhs/yam-beer/cmp/common/Avatar/Avatar.vue'
  import initStyle from './style'
  import { BeerStyleObj } from '../../../core/index'

  initStyle()

  /**
   * 顶部栏目
   */
  export default defineComponent({
    name: 'TopBar',
    components: {
      BeerIcon,
      NewBsBox,
      BeerAvatar,
    },
    props: {
      /**
       * 容器 BeerStyle
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 标题 BeerStyle
       */
      titleBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 点击头像的事件
       */
      avatarOn: {
        type: Object as PropType<Record<string, unknown>>,
        default: () => ({}),
      },
      /**
       * 透传头像的 props
       */
      avatarProps: {
        type: Object as PropType<Record<string, unknown>>,
        default: () => ({}),
      },
      /**
       * 是否显示头像，在默认 right slot 中生效
       */
      showAvatar: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
      /**
       * 标题
       */
      title: {
        type: String as PropType<string>,
      },
      /**
       * 用户名，在默认 right slot 中生效
       */
      userName: {
        type: String as PropType<string>,
      },
    },
  })
</script>
